export default __webpack_public_path__ + "static/media/LakhatasLakasfenntartas.14e16dff.jpg";